import DeleteIcon from '@mui/icons-material/Delete';
import {Box, IconButton} from '@mui/material';
import {TimePicker} from '@mui/x-date-pickers/TimePicker';
import PropTypes from 'prop-types';
import {Controller, useFormContext} from 'react-hook-form';

const ExecutionTimesSingleRow = ({index, enabled, canRemove, remove, open, onOpen, onClose}) => {
  const {control} = useFormContext();

  return (
    <Box display="flex" alignItems="center" mb={1.5}>
      <Controller
        disabled={!enabled}
        name={`executionTimes.${index}.time`}
        control={control}
        render={({field}) => (
          <TimePicker
            disabled={!enabled}
            {...field}
            desktopModeMediaQuery="xl"
            ampm={false}
            views={['hours', 'minutes']}
            minutesStep={30}
            value={field.value}
            onChange={field.onChange}
            open={open}
            onOpen={onOpen}
            onClose={onClose}
            slotProps={{
              textField: {size: 'small', fullWidth: true, disabled: !enabled}
            }}
          />
        )}
      />

      {canRemove && (
        <IconButton role="button" color="error" onClick={() => remove(index)} disabled={!enabled}>
          <DeleteIcon />
        </IconButton>
      )}
    </Box>
  );
};

ExecutionTimesSingleRow.propTypes = {
  index: PropTypes.number.isRequired,
  enabled: PropTypes.bool.isRequired,
  canRemove: PropTypes.bool.isRequired,
  remove: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onOpen: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default ExecutionTimesSingleRow;
